<main class="main-page">
  <app-start-page />
  <app-services-section />
  <app-projects-showcase />
  <app-contact-section />
</main>
